import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { listQuotes } from "../services/partnerAuthService";

const TONE = { Pending: "warning", Accepted: "success", Rejected: "danger", Expired: "secondary", Withdrawn: "secondary" };

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listQuotes()
      .then(({ data }) => setQuotes(data.data || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading quotes…</p>;

  return (
    <div>
      <h4 className="mb-3">My Quotes</h4>
      {quotes.length === 0 ? (
        <div className="partner-card partner-empty">You haven't submitted any quotes yet.</div>
      ) : (
        <div className="d-flex flex-column gap-3">
          {quotes.map((q) => (
            <div key={q._id} className="partner-card d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <h6 className="mb-1">{q.travelRequestId?.destination || "Trip"}</h6>
                <small className="text-muted">Submitted {new Date(q.createdAt).toLocaleDateString()}</small>
              </div>
              <div className="text-end">
                <div className="fw-semibold">₹{q.total}</div>
                <Badge bg={TONE[q.status] || "secondary"}>{q.status}</Badge>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
